<template>
  <el-dialog
    :visible="visible"
    :show-close="false"
    width="70%"
    class="edit-detail-dialog"
    center
    @close="handleDialogClose"
    :close-on-click-modal="false">
    <span slot="title" class="title-container">
      <span class="title-text">{{factoryName + $t('factoryLabelPrint.templateContentEditing')}}</span>
      <img
        src="@/assets/close.png"
        class="close-image"
        @click="close"
      />
    </span>
    <el-form class="el-form" :model="form" ref="refForm" :rules="rules" label-width="120px">
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.materialName') + ':'" prop="processingOrderNo">
            <el-input
              v-model.trim="form.processingOrderNo"
              name="materialName"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.specificationNo') + ':'" prop="partNo">
            <el-input
              v-model.trim="form.partNo"
              name="partNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.materialNo')" prop="materialNo">
            <el-input
              v-model="form.materialNo"
              name="materialNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('common.count')" prop="count">
            <el-input
              v-model.trim.number="form.count"
              name="count"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="9"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.qiangLiBatchNo') + ':'" prop="trackingNo">
            <el-input
              v-model.trim="form.trackingNo"
              name="batchNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
              placeholder="001-999"
            >
              <template slot="prepend">
                <el-input
                  v-model.trim="form.prependTrackingNo"
                  name="prependTrackingNo"
                  type="text"
                  autocomplete="off"
                  clearable
                  tabindex="1"
                  size="small"
                  maxlength="20"
                  style="width: 120px;"
                /></template>
              <el-select v-model="form.qiangLiAppend" slot="append" placeholder="请选择">
                <el-option label="无" value=""></el-option>
                <el-option label="-A" value="-A"></el-option>
                <el-option label="-A-SP" value="-A-SP"></el-option>
                <el-option label="-B1" value="-B1"></el-option>
                <el-option label="-B2" value="-B2"></el-option>
                <el-option label="-B3" value="-B3"></el-option>
                <el-option label="-B4" value="-B4"></el-option>
                <el-option label="-TC" value="-TC"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.productionDate') + ':'" prop="deliveryDate">
            <el-date-picker
              v-model="form.deliveryDate"
              type="date"
              size="small"
              style="width: 100%;"
              @change="changeDeliveryDate">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('common.supplierCode') + ':'" prop="supplierCode">
            {{form.supplierCode}}
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('common.stylePreview') + ':'" style="margin-bottom: 0">
      </el-form-item>
      <el-form-item>
        <el-col :span="15">
          <iframe
            id="labelIFrameQiangLiJuCaiDialogV2"
            scrolling="auto"
            width="520"
            height="260"
            frameborder="0"
            style="background: #E9E9E9;"
          ></iframe>
        </el-col>
      </el-form-item>
    </el-form>
    <span slot="footer">
        <el-button size="small" @click="close">{{$t('common.cancel')}}</el-button>
        <el-button
          size="small"
          type="primary"
          @click="submitForm">
            {{$t('common.print')}}
        </el-button>
      </span>
  </el-dialog>
</template>

<script>
  import moment from 'moment';
  import {
    validateCount,
  } from '@/utils/validate';
  import {
    initQiangLiJuCaiLabelV2Frame,
    printFactoryLabel,
  } from '@/utils/factory-label';
  import i18n from '@/lang';

  export default {
    name: "QiangLiJuCaiLabelV2Dialog",
    props: {
      factoryName: {
        type: String,
        default: '',
      },
      visible: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      const validateQiangLiBatchNo = (rule, value, callback) => {
        if (!/^IC56-\d{4}-$/.test(this.form.prependTrackingNo)) {
          callback(new Error(i18n.t('factoryLabelPrint.qiangLiBatchNoFormatIncorrect')));
          return;
        }
        if (!/^(00[1-9]|0[1-9][0-9]|[1-9]\d{2})$/.test(value)) {
          callback(new Error(i18n.t('factoryLabelPrint.qiangLiBatchNoFormatIncorrect')));
          return;
        }
        callback();
      };
      return {
        form: {
          processingOrderNo: '',
          productName: 'IC56',
          partNo: undefined,
          materialNo: undefined,
          orderNo: undefined,
          count: undefined,
          trackingNo: undefined,
          prependTrackingNo: 'IC56-',
          qiangLiAppend: '',
          deliveryDate: undefined,
          supplierCode: 'IC56',
        },
        rules: {
          processingOrderNo: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.materialNameCanNotBeEmptyV2')
          }],
          materialNo: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.materialNoCanNotBeEmpty')
          }],
          partNo: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.specificationNoCanNotBeEmpty')
          }],
          count: [{
            required: true,
            trigger: 'blur',
            validator: validateCount
          }],
          deliveryDate: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.productionDateCanNotBeEmpty')
          }],
          trackingNo: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.qiangLiBatchNoCanNotBeEmpty')
          }, {
            required: true,
            trigger: 'blur',
            validator: validateQiangLiBatchNo
          }],
        }
      };
    },
    computed: {
      deliveryDateVal() {
        const {
          deliveryDate,
        } = this.form;
        if (!deliveryDate) {
          return '';
        }
        return moment(deliveryDate).format('YYMM') + '-';
      }
    },
    watch: {
      visible(newValue) {
        if (newValue) {
          setTimeout(() => {
            this.initQiangLiJuCaiLabelV2Frame();
          });
        }
      }
    },
    methods: {
      handleDialogClose() {
        this.close();
      },
      close() {
        this.$emit('update:visible', false);
        this.$emit('close');
        if (this.$refs.refForm && typeof this.$refs.refForm.clearValidate === 'function') {
          this.$refs.refForm.clearValidate();
        }
      },
      changeDeliveryDate() {
        const {
          deliveryDate,
        } = this.form;
        if (!deliveryDate) {
          return 'IC56-';
        }
        this.form.prependTrackingNo = 'IC56-' + moment(deliveryDate).format('YYMM') + '-';
        this.$refs.refForm.validateField(['trackingNo']);
      },
      submitForm() {
        this.$refs.refForm.validate(async (valid) => {
          if (valid) {
            this.printQiangLiJuCaiLabelFrame();
          }
        });
      },
      initQiangLiJuCaiLabelV2Frame() {
        let iframe = document.getElementById('labelIFrameQiangLiJuCaiDialogV2');
        iframe = initQiangLiJuCaiLabelV2Frame({
          iframe,
          machineHandNo: '行驱动芯片',
          partNo: 'LS9929S SSOP24 卷装',
          materialNo: '10102243',
          count: 25000,
          deliveryDate: '2018-05-12',
          trackingNo: 'IC56-1805-001'
        });
        iframe.contentWindow.document.close();
      },
      printQiangLiJuCaiLabelFrame() {
        const {
          processingOrderNo,
          partNo,
          materialNo,
          count,
          trackingNo,
          prependTrackingNo,
          qiangLiAppend,
          deliveryDate,
        } = this.form;
        let iframe = document.getElementById('labelIFrameQiangLiJuCaiDialogV2');
        iframe = initQiangLiJuCaiLabelV2Frame({
          iframe,
          machineHandNo: processingOrderNo,
          partNo,
          materialNo,
          count,
          trackingNo: `${prependTrackingNo}${trackingNo}${qiangLiAppend || ''}`,
          deliveryDate,
        });
        iframe.contentWindow.document.close();
        printFactoryLabel(iframe);
      },
    }
  }
</script>

<style scoped>
  .title-container {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: space-between;
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
    padding: 10px 15px;
    align-items: center;
  }

  .title-text {
    color: #404040;
    font-size: 16px;
  }

  .el-form {
    margin: 0 30px;
  }

  .close-image {
    width: 22px;
    height: 22px;
    cursor: pointer;
    padding: 0 10px;
  }
  /deep/ .el-input-group__append {
    width: 70px;
  }
</style>
<style>
  .edit-detail-dialog .el-dialog__header {
    padding: 0;
  }
</style>
